import React from "react";

const Services = () => {
  const services = [
    {
      name: "Custom websites and web apps",
      desc: "Build or improve custom websites and dashboards with attention to user experience, security, performance, and future maintenance.",
      icon: "fas fa-code",
    },
    {
      name: "Mobile application delivery",
      desc: "Develop iOS and Android applications, connect them to a backend, and move the product from prototype toward a usable release.",
      icon: "fas fa-mobile",
    },
    {
      name: "Product architecture and backend",
      desc: "Design APIs, data models, and backend structures for products that need to be secure, maintainable, and ready to grow.",
      icon: "fas fa-cloud",
    },
  ];

  return (
    <section id="services" className="section bg-light">
      <div className="container">
        <p className="text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">What I do</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          A technical approach matched to your project
        </h2>

        <div className="row gy-5 mt-5">
          {services.map((service, index) => (
            <div className="col-sm-6 col-lg-4 wow fadeInUp" key={index}>
              <div className="featured-box text-center px-md-4">
                <div className="featured-box-icon text-primary text-13">
                  <i className={service.icon} />
                </div>
                <h3 className="text-6 fw-600 mb-3">{service.name}</h3>
                <p className="text-muted mb-0">{service.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
